import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const WeeklyInfractionChart = ({ data = [] }) => {
  const chartOptions = {
    chart: {
      type: "column",
    },
    title: {
      text: "Infractions Hebdomadaires",
      align: "center",
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      categories: data.map((item) => item.name.slice(5)),
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: "Revenu",
      },
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
      },
    },
    series: [
      {
        name: "Infraction non payée",
        data: data.map(
          (item) => item.infraction - parseInt(item.infractionPaid)
        ),
      },
      {
        name: "Infraction payée",
        data: data.map((item) => parseInt(item.infractionPaid)),
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
};

export default WeeklyInfractionChart;
